import { render, staticRenderFns } from "./WarehouseReturnsScanHistory.vue?vue&type=template&id=96ab5852&"
import script from "./WarehouseReturnsScanHistory.vue?vue&type=script&lang=ts&"
export * from "./WarehouseReturnsScanHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports